<template>
    <a-modal
    :title="title"
    :width="800"
    :ok=false
    :visible="visible"
    :confirmLoading="confirmLoading"
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
      <a-spin :spinning="confirmLoading">
        <a-tabs v-model="activeKey" @change="changeTab">
          <a-tab-pane :key="1" :tab="$t('数据详情')">
            <detail-list :col="2">
              <detail-list-item :term="$t('区域名称')">{{model.userAreaName}}</detail-list-item>
              <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
              <!--<detail-list-item term="表类型">{{model.userName}}</detail-list-item>-->
              <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
              <detail-list-item :term="$t('表安装地址')">{{model.userMeterAddr}}</detail-list-item>
              <detail-list-item :term="$t('用户编号')">{{model.meterUserId}}</detail-list-item>
              <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
              <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
              <!--<detail-list-item term="告警描述">{{model.meterWarnDetail}}</detail-list-item>-->
              <detail-list-item :term="$t('价格名称')">{{model.wtName}}</detail-list-item>
              <detail-list-item :term="$t('合计单价(元)')">{{model.wtTotalPrice}}</detail-list-item>
              <detail-list-item :term="$t('告警规则')">{{model.warnName}}</detail-list-item>
              <detail-list-item :term="$t('报表日期')">{{model.reportDate}}</detail-list-item>
              <detail-list-item :term="$t('日用量')">{{model.dayUse}}m³</detail-list-item>
              <detail-list-item :term="$t('处理状态')">{{model.meterDealStatus==2?$t('已处理'):model.meterDealStatus==1?$t('处理中'): $t('未处理')}}</detail-list-item>
              <detail-list-item :term="$t('处理描述')">{{model.meterDealStatus==2?model.meterDealDescription2:model.meterDealStatus==1?model.meterDealDescription1: model.meterDealDescription0}}</detail-list-item>
            </detail-list>
          </a-tab-pane>
          <a-tab-pane :key="2" :tab="$t('历史流量记录')">
            <div class="form-contain">
              <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                  <a-row :gutter="24">
                    <a-col :xl="6" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('处理状态')">
                        <a-select v-model="queryParam.meterDealStatus" :placeholder="$t('请选择处理状态')">
                          <a-select-option value="0">
                            {{ $t('未处理') }}
                          </a-select-option>
                          <a-select-option value="1">
                            {{ $t('处理中') }}
                          </a-select-option>
                          <a-select-option value="2">
                            {{ $t('已处理') }}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :xl="12" :lg="7" :md="8" :sm="24">
                      <a-form-item :label="$t('报表日期')">
                        <a-range-picker
                          v-model="date"
                          format="YYYY-MM-DD"
                          :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                          @change="onDateRangeChange"
                        />
                      </a-form-item>
                    </a-col>
                    <a-col :xl="8" :lg="7" :md="8" :sm="24">
                      <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                      </span>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
                <a-table 
                  :columns="columns"
                  :dataSource="dataSource"
                  :scroll="{x:true}"
                  rowKey='id'
                  size="middle"
                  :pagination="ipagination"
                  @change="handleTableChange"
                  class="j-table-force-nowrap"
                >
                  <span slot="wtPriceSlot" slot-scope="text, record">
                    <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
                    <span v-else>--</span>
                  </span>
                  <span slot="meterDealStatus" slot-scope="text, record">
                    <label v-if="record.meterDealStatus === 1" class="doing-status">{{ $t('处理中') }}</label>
                    <label v-else-if="record.meterDealStatus === 2" class="finish-status">{{ $t('已处理') }}</label>
                    <label v-else class="wait-status">{{ $t('未处理') }}</label>
                  </span>
                </a-table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </a-modal>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterUserAccountForm',
    mixins:[JeecgListMixin],
    components: {
      JFormContainer,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        model: {},
        title: '',
        confirmLoading: false,
        disableSubmit:false,
        visible: false,
        validatorRules: {
        },
        url: {
          add: "/jeecg-charge/meter/meterUserAccount/add",
          edit: "/jeecg-charge/meter/meterUserAccount/edit",
          queryById: "/jeecg-charge/meter/meterUserAccount/queryById",
          list: "/jeecg-charge/meter/meterUseWarnRecord/list"
        },
        date:[],
        dateType: 2,
        activeKey: 1,
        disableMixinCreated: true,
        uniqueParam: {}
      }
    },
    created () {
    },
    computed: {
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            ellipsis: true,
          },{
            title: this.$t('处理进度'),
            align:"center",
            dataIndex: 'meterDealStatus',
            scopedSlots: { customRender: 'meterDealStatus' },
            width:100,
            ellipsis: true
          }/*,{
            title:'告警描述',
            align:"center",
            dataIndex: 'meterWarnDetail',
            width: 100,
            ellipsis: true,
          }*/,{
            title: this.$t('告警规则'),
            align:"center",
            dataIndex: 'warnName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('日用量(m³)'),
            align:"center",
            dataIndex: 'dayUse',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('报表日期'),
            align:"center",
            dataIndex: 'reportDate',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('价格名称'), //对应priceinfo表中的主键id
            align:"center",
            dataIndex:'wtPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'wtPriceSlot' },
          }
        ]
      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.uniqueParam.userKeyId = this.model.userKeyId;
        this.changeTab(1);
        this.disableSubmit = true;
        this.visible = true;
      },
      shut() {
        this.activeKey = 1;
        this.queryParam = {}
      },
      close () {
        this.$emit('close');
        this.shut();
        this.disableSubmit = false;
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.formModal.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })

          }
        })
      },
      handleCancel () {
        this.close()
      },
      changeTab() {
        if(this.activeKey == 2) {
          this.loadData(1)
        }
      }
    }
  }
</script>
<style scoped>
.detail-list >>> .term{
  line-height: 22px;
}
</style>